export default "__VITE_ASSET__DBGucy46__"